<template>
  <v-row justify="center">
    <v-col class="text-center pt-5" cols="12" sm="10" md="8" lg="6">
      <v-card outlined class="pa-10">
        <p class="display-1">
          2021年度 スポーツ教材提供申請の募集は終了いたしました。
        </p>
        <p>
          2021年度
          スポーツ教材提供申請の募集は2021年4月19日をもって終了いたしました。
          <br />たくさんのご応募ありがとうございました。
        </p>
        <p class="mb-10">公益財団法人ヤマハ発動機スポーツ振興財団 事務局</p>
        <v-btn class="primary" @click="closeWindow">閉じる</v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "KyoikuInputPeriod",
  methods: {
    closeWindow() {
      window.open("about:blank", "_self").close();
    },
  },
};
</script>